import PaiementDetailController from './paiement.detail.controller';

export default {
    template: require('./paiement.detail.html'),
    controller: PaiementDetailController
};
